
export const actions = {
  async save({commit}, {seo}) {
    const result = await this.$axios.$post('/SEO', seo)
    return result
  },
}
